import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Chapters from "@/components/landing/Chapters";
import WhatYouGet from "@/components/landing/WhatYouGet";
import RegisterSection from "@/components/landing/RegisterSection";
import HowItWorks from "@/components/landing/HowItWorks";
import Founder from "@/components/landing/Founder";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import StickyJoinBar from "@/components/landing/StickyJoinBar";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Chapters />
        <WhatYouGet />
        <RegisterSection idPrefix="form" />
        <HowItWorks />
        <Founder />
        <FinalCTA />
      </main>
      <Footer />
      <StickyJoinBar />
    </>
  );
}
